import { render, staticRenderFns } from "./SetTime.vue?vue&type=template&id=06216f3c&scoped=true&lang=pug&"
import script from "./SetTime.vue?vue&type=script&lang=js&"
export * from "./SetTime.vue?vue&type=script&lang=js&"
import style0 from "./SetTime.vue?vue&type=style&index=0&id=06216f3c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06216f3c",
  null
  
)

export default component.exports